import type { ReactNode } from "react";

// The bar under a page's head (byj-1wv.51.3, byj-1wv.51.4), in view whether
// the side panel is open, folded or under the main pane: how the thing
// stands, a dot before it in its state's colour (`is-<state>`); what else
// is so, muted; and what may be done about it, at the bar's end. A share's
// owner's bar (OwnerConsole's ShareBar) and a recording's (the review page's).

export function StateBar({ className, label, state, stateLabel, children, actions, testid }: {
  /** the bar's own class, beside share-bar */
  className?: string;
  /** its name, for a screen reader */
  label: string;
  /** its state's class, `is-<state>`, which colours it */
  state: string;
  stateLabel: ReactNode;
  /** what else is so */
  children?: ReactNode;
  actions?: ReactNode;
  testid?: string;
}) {
  return (
    <div className={`share-bar${className ? ` ${className}` : ""} is-${state}`} role="group" aria-label={label} data-testid={testid}>
      {stateLabel}
      {children}
      <span className="share-bar-actions">{actions}</span>
    </div>
  );
}
